module.exports = __webpack_public_path__ + "img/video-record-icon.6b036e1e.svg";